import React from 'react';

import { Box, Typography } from '@mui/material';

import { PillTone } from 'types/ProjectTypes';

const Pill = ({
  label = 'DRAFT',
  tone,
  withDot = true,
  fullWidth = false,
}: {
  label: string;
  tone: PillTone;
  withDot?: boolean;
  fullWidth?: boolean;
}) => {
  const tones: Record<PillTone, { color: string; bg: string; border: string }> = {
    REJECTED: { color: '#f44336', bg: 'rgba(244,67,54,0.14)', border: 'rgba(244,67,54,0.4)' },
    PENDING_APPROVAL: { color: '#d98b3a', bg: 'rgba(217,139,58,0.14)', border: 'rgba(217,139,58,0.4)' },
    DRAFT: { color: '#d98b3a', bg: 'rgba(217,139,58,0.14)', border: 'rgba(217,139,58,0.4)' },
    SUPERSEDED: { color: '#9a9a9a', bg: 'rgba(255,255,255,0.06)', border: 'transparent' },
    APPROVED: { color: '#a3d139', bg: 'transparent', border: '#a3d139' },
  };
  const t = tones[tone] ?? tones.DRAFT;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1.25,
        py: 0.5,
        borderRadius: 1,
        border: 1,
        borderColor: t.border,
        bgcolor: t.bg,
        color: t.color,
        width: fullWidth ? '100%' : 'auto',
        boxSizing: 'border-box',
      }}>
      {withDot && (
        <Box
          sx={{
            width: 7,
            height: 7,
            borderRadius: '50%',
            bgcolor: t.color,
            flexShrink: 0,
          }}
        />
      )}
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
        }}>
        {label}
      </Typography>
    </Box>
  );
};

export default Pill;
